module.exports = __webpack_public_path__ + "static/media/6.90ed47e5.JPG";